/**
 * Storage abstraction. In Telegram WebView we'd ideally use the Mini App
 * CloudStorage API (per-user, synced across devices), but for the initial
 * scaffold localStorage is fine. Swap this implementation when CloudStorage
 * support is wired through @tma.js/sdk-react.
 */

export const storage = {
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      /* ignore quota / privacy mode errors */
    }
  },
  remove(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* noop */
    }
  },
};

export const StorageKey = {
  Token: 'qlash.token',
  UserId: 'qlash.userId',
  SelectedGameId: 'qlash.selectedGameId',
} as const;
